/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// 添加购物车
window.LSShopify = window.LSShopify || {};

LSShopify.addToCart = function ({ variantId, quantity = 1, button }) {
  if (!variantId) return;

  if (button) {
    button.disabled = true;
    button.classList.add('is-loading');
  }

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(r => r.json())
  .then( async data => {
    document.dispatchEvent(
      new CustomEvent('ls:cart:updated', { detail: data })
    );
    return fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            cartData["sections"] = data["sections"];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartData,
                  openMiniCart: true
                },
              })
            );
          });
  })
  .catch(console.error)
  .finally(() => {
    if (button) {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
};
// 添加购物车



const ScrollRevealManager = (() => {
    // ==========================================
    // 1. 全局配置
    // ==========================================
    const config = {
        className: 'reveal-on-scroll', // 触发动画的类名
        activeClass: 'is-visible',     // 激活后的类名
        threshold: 0.1,                // 触发交叉的比例
        baseDelay: 0.1,                // 递增延迟时间 (秒)
    };

    // ==========================================
    // 2. 核心观察者实例
    // ==========================================
    let observer = null;

    const getObserver = () => {
        if (!observer) {
            observer = new IntersectionObserver((entries) => {
                let delayCount = 0;
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const el = entry.target;
                        if (!el.classList.contains(config.activeClass)) {
                            el.style.transitionDelay = `${delayCount * config.baseDelay}s`;
                            el.classList.add(config.activeClass);
                            observer.unobserve(el);
                            delayCount++;
                        }
                    }
                });
            }, { threshold: config.threshold });
        }
        return observer;
    };

    // ==========================================
    // 3. 核心行为方法
    // ==========================================
    const core = {
        /**
         * 扫描并监听指定容器内的元素
         */
        scan(container = document) {
            const elements = container.querySelectorAll(`.${config.className}`);
            const obs = getObserver();
            
            elements.forEach(el => {
                if (!el.classList.contains(config.activeClass)) {
                    obs.observe(el);
                }
            });
        },

        /**
         * 强制立即显示指定容器内的元素（无动画延迟）
         */
        reveal(container = document) {
            const elements = container.querySelectorAll(`.${config.className}`);
            elements.forEach(el => {
                el.style.transitionDelay = '0s';
                el.classList.add(config.activeClass);
                if (observer) observer.unobserve(el);
            });
        }
    };

    // ==========================================
    // 4. 环境与事件绑定 (自动执行)
    // ==========================================
    const bindEvents = () => {
        // 1. 正常用户端：页面加载完毕后扫描整个文档
        document.addEventListener('DOMContentLoaded', () => core.scan());

        // 2. Shopify 编辑器端：适配后台各种生命周期
        if (window.Shopify && Shopify.designMode) {
            // 模块重新加载时：只扫描发生变化的该模块
            document.addEventListener('shopify:section:load', (e) => core.scan(e.target));
            
            // 选中模块/区块时：立即显示该区域（移除延迟），防止在后台编辑时元素因等待动画而处于隐藏状态
            document.addEventListener('shopify:section:select', (e) => core.reveal(e.target));
            document.addEventListener('shopify:block:select', (e) => core.reveal(e.target));
        }
    };

    // 自动启动事件绑定
    bindEvents();

    // ==========================================
    // 5. 暴露公共 API（供如果有特定需求时手动调用）
    // ==========================================
    return {
        update: core.scan,
        showAll: core.reveal
    };
})();

// 页面加载完成后自动运行
document.addEventListener('DOMContentLoaded', () => ScrollRevealManager.update());

class ScrollHandle extends HTMLElement {
    constructor() {
        super();
        this._onScroll = this.onScroll.bind(this);
        this._onResize = this.onResize.bind(this);
        this._ticking = false;
        this._isListening = false;
        this.target = null;
        this.observer = null;
    }

    connectedCallback() {
        const targetId = this.getAttribute('target-id');
        this.target = targetId ? document.getElementById(targetId) : this;

        if (!this.target) return;

        this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (!entry) return;

            if (entry.isIntersecting) {
                this.startListening();
                this.calculateProgress();
            } else {
                this.stopListening();
            }
        }, {
            threshold: 0,
            rootMargin: '100px 0px'
        });

        this.observer.observe(this);

        window.addEventListener('resize', this._onResize, { passive: true });

        // 初始化立即同步一次状态
        this.calculateProgress();
    }

    disconnectedCallback() {
        this.stopListening();
        window.removeEventListener('resize', this._onResize);

        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    startListening() {
        if (this._isListening) return;
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._isListening = true;
    }

    stopListening() {
        if (!this._isListening) return;
        window.removeEventListener('scroll', this._onScroll);
        this._isListening = false;
    }

    onResize() {
        this.calculateProgress();
    }

    onScroll() {
        if (this._ticking) return;

        this._ticking = true;
        requestAnimationFrame(() => {
            this.calculateProgress();
            this._ticking = false;
        });
    }

    calculateProgress() {
        if (!this.target) return;

        const rect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const height = rect.height || 1;

        let startTop;
        let endTop;
        let progress = 0;

        if (height <= viewportHeight) {
            // 普通元素：沿用你原本规则
            startTop = 0;
            endTop = -height / 2;
        } else {
            // 超高元素：
            // 开始点 = 元素底部完全进入视口时
            // rect.bottom = viewportHeight
            // => startTop = viewportHeight - height
            startTop = viewportHeight - height;

            // 开始时元素在视口内剩余的高度
            const startVisibleHeight = viewportHeight;

            // 结束点 = 从开始点继续滚动“开始剩余可见高度的一半”
            endTop = startTop - startVisibleHeight / 2;
        }

        if (rect.top >= startTop) {
            progress = 0;
        } else if (rect.top <= endTop) {
            progress = 1;
        } else {
            progress = (startTop - rect.top) / (startTop - endTop);
        }

        progress = Math.max(0, Math.min(1, progress));
        this.applyTransform(progress);
    }

    applyTransform(progress) {
        const p = +(progress * 4).toFixed(3);
        const r = +(progress * 40).toFixed(1);

        this.target.style.clipPath = `inset(0px ${p}% ${p}% round ${r}px)`;
    }
}

customElements.define('scroll-handle', ScrollHandle);

class LsCarouselTabs extends HTMLElement {
    constructor() {
        super();
        this.step = 0;
        this.index = 0;
        this.maxIndex = 0;
        this.tailOffset = 0;
        this.maxOffset = 0;
        this.isDragging = false;
        this.startX = 0;
        this.dragStartTranslate = 0;
        this.moveThreshold = 5;
        this.raf = 0;
        this.resizeObserver = null;
        this.activeMode = 'pc';
        this.boundOnResize = this.onResize.bind(this);
        this.boundOnPointerMove = e => this.onMove(e);
        this.boundOnPointerUp = () => this.onUp();
    }

    connectedCallback() {
        this.cache();
        this.bind();
        this.initActiveTab();
        this.observeResize();

        this.bindProductEvents();
    }

    bindProductEvents() {
        this.addEventListener('click', e => {
            const swatch = e.target.closest('.ls-card__dot');
            if (swatch && this.contains(swatch)) {
            this.onColorSwatchClick(swatch);
            return;
            }

            const addBtn = e.target.closest('.ls-btn-add');
            if (addBtn && this.contains(addBtn)) {
            this.onAddToCartClick(addBtn);
            }
        });
    }

    onColorSwatchClick(swatch) {
        const card = swatch.closest('.ls-card');
        if (!card) return;

        const colorsWrap = swatch.parentElement;
        const optionIndex = Number(colorsWrap.dataset.optionIndex);
        const value = swatch.dataset.value;

        // active 状态（逻辑）
        colorsWrap
            .querySelectorAll('.ls-card__dot')
            .forEach(el => el.classList.remove('active'));

        swatch.classList.add('active');

        // variants 数据来自 data-variants
        let variants;
        try {
            variants = JSON.parse(card.dataset.variants);
        } catch (e) {
            return;
        }

        const matched = variants.find(v =>
            v.options && v.options[optionIndex] === value
        );

        if (!matched) return;

        /* 更新 variantId */
        const addBtn = card.querySelector('.ls-btn-add');
        if (addBtn) {
            addBtn.dataset.variantId = matched.id;
        }

        /* 切换图片（Variant Image） */
        const imageSrc =
            matched?.featured_image?.src ||
            matched?.image?.src ||
            '';

        if (imageSrc) {
            const img = card.querySelector('.ls-product-main-image');
            if (img) {
                img.src = imageSrc.replace(/(\.[^.]*)$/, '_400x$1');
            }
        }
    }

    onAddToCartClick(button) {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        LSShopify.addToCart({
            variantId,
            quantity: 1,
            button
        });
    }

    disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('orientationchange', this.boundOnResize);
        window.removeEventListener('pointermove', this.boundOnPointerMove);
        window.removeEventListener('pointerup', this.boundOnPointerUp);
        window.removeEventListener('pointercancel', this.boundOnPointerUp);
        if (this.raf) cancelAnimationFrame(this.raf);
    }

    cache() {
        this.tabs = this.querySelectorAll('.ls-tab');
        this.panels = this.querySelectorAll('.ls-panel');
        this.prev = this.querySelector('.ls-prev');
        this.next = this.querySelector('.ls-next');
        this.activePanel = this.querySelector('.ls-panel.active') || this.panels[0];
        this.track = this.activePanel?.querySelector('.ls-track');
        this.view = this.activePanel?.querySelector('.ls-view');
    }

    bind() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });

        this.prev.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));

        this.panels.forEach(panel => {
            const track = panel.querySelector('.ls-track');
            track.addEventListener('pointerdown', e => {
                if (e.pointerType === 'mouse' && e.button !== 0) return;

                const interactive = e.target.closest(
                    'a, button,.ls-card__dot'
                );

                if (interactive) {
                    return;
                }
                e.preventDefault();
                this.onDown(e, track);
            });
        });

        window.addEventListener('pointermove', this.boundOnPointerMove, { passive: true });
        window.addEventListener('pointerup', this.boundOnPointerUp);
        window.addEventListener('pointercancel', this.boundOnPointerUp);
        window.addEventListener('orientationchange', this.boundOnResize);
    }

    initActiveTab() {
        const activeTab = this.querySelector('.ls-tab.active') || this.tabs[0];
        const tabName = activeTab?.dataset.tab;
        if (tabName) this.switchTab(tabName, true);
    }

    observeResize() {
        if (!('ResizeObserver' in window)) {
            window.addEventListener('resize', this.boundOnResize, { passive: true });
            this.onResize();
            return;
        }

        this.resizeObserver = new ResizeObserver(() => {
            if (this.raf) cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.onResize());
        });

        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.activePanel.querySelector('.ls-view'));
        this.onResize();
    }

    getGap() {
        const isMobile = window.matchMedia('(max-width: 991px)').matches;
        const raw = this.getAttribute(isMobile ? 'gap-mobile' : 'gap-pc');
        const gap = Number.parseFloat(raw);
        return Number.isFinite(gap) ? gap : (isMobile ? 20 : 48);
    }

    getMetrics() {
        const card = this.track.querySelector('.ls-card');
        if (!card) return null;

        const gap = this.getGap();
        const cardWidth = card.getBoundingClientRect().width;
        const viewWidth = this.view.getBoundingClientRect().width;
        const cardCount = this.track.querySelectorAll('.ls-card').length;
        const totalWidth = cardCount * cardWidth + Math.max(0, cardCount - 1) * gap;
        const maxOffset = Math.max(0, totalWidth - viewWidth);
        const step = cardWidth + gap;
        const maxIndex = Math.floor(maxOffset / step);
        const tailOffset = maxOffset - maxIndex * step;

        return { gap, cardWidth, viewWidth, cardCount, totalWidth, maxOffset, step, maxIndex, tailOffset };
    }

    onResize() {
        const mode = window.matchMedia('(max-width: 991px)').matches ? 'mobile' : 'pc';
        const modeChanged = mode !== this.activeMode;
        this.activeMode = mode;

        this.track = this.activePanel.querySelector('.ls-track');
        this.view = this.activePanel.querySelector('.ls-view');

        const metrics = this.getMetrics();
        if (!metrics) return;

        this.step = metrics.step;
        this.maxIndex = metrics.maxIndex;
        this.maxOffset = metrics.maxOffset;
        this.tailOffset = metrics.tailOffset;

        if (this.index > this.maxIndex + 1) this.index = this.maxIndex + 1;

        this.track.style.setProperty('--carousel-gap', `${metrics.gap}px`);
        this.track.style.transition = modeChanged ? 'none' : 'transform .35s ease';
        this.track.style.transform = `translateX(${this.getTranslateByIndex(this.index)}px)`;

        requestAnimationFrame(() => {
            this.updateArrowState();
            if (modeChanged) this.track.style.transition = 'transform .35s ease';
        });
    }

    getTranslateByIndex(index) {
        if (index <= this.maxIndex) return -index * this.step;
        return -(this.maxIndex * this.step + this.tailOffset);
    }

    getIndexByTranslate(translate) {
        const abs = Math.abs(translate);
        const boundary = this.maxIndex * this.step;

        if (abs >= boundary + this.tailOffset - 0.5) return this.maxIndex + 1;
        if (abs >= boundary - 0.5) return this.maxIndex;
        return Math.round(abs / this.step);
    }

    switchTab(name, silent = false) {
        this.tabs.forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === name);
        });

        this.panels.forEach(panel => {
            const active = panel.dataset.panel === name;
            panel.classList.toggle('active', active);
            if (active) this.activePanel = panel;
        });

        this.track = this.activePanel.querySelector('.ls-track');
        this.view = this.activePanel.querySelector('.ls-view');
        this.index = 0;
        this.dragStartTranslate = 0;
        this.track.style.transition = 'none';
        this.track.style.transform = 'translateX(0px)';
        this.track.classList.remove('dragging');

        this.onResize();
        if (!silent) this.updateArrowState();
    }

    clampTranslate(value) {
        const min = -(this.maxIndex * this.step + this.tailOffset);
        const max = 0;
        return Math.max(min, Math.min(max, value));
    }

    rubberBand(value) {
        const min = -(this.maxIndex * this.step + this.tailOffset);
        const max = 0;
        const strength = 0.35;
        if (value > max) return max + (value - max) * strength;
        if (value < min) return min + (value - min) * strength;
        return value;
    }

    move(dir) {
        const nextIndex = this.index + dir;
        const lastIndex = this.maxIndex + 1;

        if (nextIndex < 0 || nextIndex > lastIndex) return;

        this.index = nextIndex;
        this.track.style.transition = 'transform .35s ease';
        this.track.style.transform = `translateX(${this.getTranslateByIndex(this.index)}px)`;
        this.updateArrowState();
    }

    updateArrowState() {
        const lastIndex = this.maxIndex + 1;
        this.prev.disabled = this.index <= 0;
        this.next.disabled = this.index >= lastIndex;
    }

    onDown(e, track) {
        this.isDragging = true;
        this.track = track;
        this.startX = e.clientX;
        this.dragStartTranslate = this.getTranslateByIndex(this.index);
        this.track.classList.add('dragging');
        this.track.style.transition = 'none';
        this.track.setPointerCapture?.(e.pointerId);
    }

    onMove(e) {
        if (!this.isDragging || !this.track) return;
        if (e.pointerType === 'mouse' && e.buttons !== 1) return;

        const dx = e.clientX - this.startX;
        if (Math.abs(dx) < this.moveThreshold) return;

        const raw = this.dragStartTranslate + dx;
        const eased = this.rubberBand(raw);
        this.track.style.transform = `translateX(${eased}px)`;
    }

    onUp() {
        if (!this.isDragging || !this.track) return;

        this.isDragging = false;
        this.track.classList.remove('dragging');
        this.track.style.transition = 'transform .35s ease';

        const currentTranslate = this.getCurrentTranslate();
        const diff = currentTranslate - this.dragStartTranslate;
        
        // 核心修改：设定一个较小的触发距离（例如 40px）
        // 只要拖动超过 40px，就根据方向切换 Index
        const swipeThreshold = 40; 
        const lastIndex = this.maxIndex + 1;

        if (Math.abs(diff) > swipeThreshold) {
            if (diff < 0) {
                // 向左拖，索引增加
                this.index = Math.min(lastIndex, this.index + 1);
            } else {
                // 向右拖，索引减少
                this.index = Math.max(0, this.index - 1);
            }
        }

        this.track.style.transform = `translateX(${this.getTranslateByIndex(this.index)}px)`;
        this.updateArrowState();
    }

    getCurrentTranslate() {
        const style = getComputedStyle(this.track).transform;
        if (style === 'none') return 0;
        return new DOMMatrixReadOnly(style).m41;
    }
}

customElements.define('ls-carousel-tabs', LsCarouselTabs);

class CrvMarquee extends HTMLElement {
    connectedCallback() {
        this.vp = this.querySelector('.crv__vp');
        this.trk = this.querySelector('.crv__trk');
        // 保存原始 DOM 片段，避免重复 clone 导致的内存膨胀
        if (!this.originalChildren) {
            this.originalChildren = Array.from(this.trk.children);
        }
        this.count = this.originalChildren.length;

        this.width = 0;
        this.x = 0;
        this.baseSpeed = 0.02;

        this.hover = false;
        this.dragging = false;
        this.inertia = false;

        this.startX = 0;
        this.startPos = 0;
        this.currentX = 0;
        this.lastMoveTime = 0;
        this.vx = 0;

        this.last = 0;
        this.raf = 0;
        this.timer = 0;
        this.rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.friction = 0.92;
        this.minMove = 6;

        this.initDOM();
        this.bind();
        this.refresh();
        this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        this.ro?.disconnect();
        document.removeEventListener('visibilitychange', this._vis);
        this.vp.removeEventListener('pointerdown', this._down);
        window.removeEventListener('pointermove', this._move);
        window.removeEventListener('pointerup', this._up);
        window.removeEventListener('contextmenu', this._up);
    }

    initDOM() {
        // 只在初始化时克隆，保持 trk 内有两组相同的元素以实现无缝循环
        this.trk.innerHTML = '';
        const fragment = document.createDocumentFragment();
        [...this.originalChildren, ...this.originalChildren].forEach(n => {
            fragment.appendChild(n.cloneNode(true));
        });
        this.trk.appendChild(fragment);
    }

    calc() {
        const items = Array.from(this.trk.children).slice(0, this.count);
        const gap = parseFloat(getComputedStyle(this.trk).gap) || 0;
        this.width = 0;
        items.forEach((item, i) => {
            this.width += item.getBoundingClientRect().width;
            if (i !== items.length - 1) this.width += gap;
        });
        // 加上最后一个元素到克隆组第一个元素的间距
        if (this.count > 0) this.width += gap;
    }

    wrap(v) {
        if (this.width <= 0) return 0;
        // 使用取模运算替代 while 循环，更高效
        return (v % this.width - this.width) % this.width;
    }

    render() {
        this.trk.style.transform = `translate3d(${this.x}px,0,0)`;
    }

    tick(ts) {
        if (!this.last) this.last = ts;
        const dt = Math.min(ts - this.last, 100); // 限制 dt 防止标签切换后的巨大跳跃
        this.last = ts;

        if (!this.rm) {
            if (this.dragging) {
                const target = this.startPos + (this.currentX - this.startX);
                this.x = this.wrap(target);
                this.render();
            } else if (this.inertia) {
                this.x += this.vx * dt;
                this.vx *= Math.pow(this.friction, dt / 16.67);
                this.x = this.wrap(this.x);
                this.render();
                if (Math.abs(this.vx) < 0.01) this.inertia = false;
            } else if (!this.hover) {
                this.x -= this.baseSpeed * dt;
                this.x = this.wrap(this.x);
                this.render();
            }
        }

        this.raf = requestAnimationFrame(this.tick.bind(this));
    }

    refresh() {
        this.calc();
        this.x = this.wrap(this.x);
        this.render();
    }

    bind() {
        this._enter = () => this.hover = true;
        this._leave = () => this.hover = false;

        this._down = e => {
            if (e.button !== 0) return; // 只响应左键
            this.dragging = true;
            this.inertia = false;
            this.startX = e.clientX;
            this.currentX = e.clientX;
            this.startPos = this.x;
            this.lastMoveTime = performance.now();
            this.vx = 0;
            this.moveSum = 0;
            this.vp.setPointerCapture(e.pointerId);
        };

        this._move = e => {
            if (!this.dragging) return;
            const now = performance.now();
            const dx = e.clientX - this.currentX;
            const dt = Math.max(now - this.lastMoveTime, 16);

            this.currentX = e.clientX;
            this.lastMoveTime = now;
            this.moveSum += Math.abs(dx);

            // 平滑速度计算
            this.vx = this.vx * 0.7 + (dx / dt) * 0.3;
        };

        this._up = () => {
            if (!this.dragging) return;
            this.dragging = false;

            if (this.moveSum < this.minMove) {
                this.inertia = false;
                this.vx = 0;
            } else {
                this.inertia = Math.abs(this.vx) > 0.05;
            }
        };

        this._vis = () => {
            if (document.hidden) {
                cancelAnimationFrame(this.raf);
            } else {
                this.last = 0;
                this.raf = requestAnimationFrame(this.tick.bind(this));
            }
        };

        this.vp.addEventListener('mouseenter', this._enter);
        this.vp.addEventListener('mouseleave', this._leave);
        this.vp.addEventListener('pointerdown', this._down);

        // 在 window 上监听，防止鼠标移出视口丢失事件
        window.addEventListener('pointermove', this._move);
        window.addEventListener('pointerup', this._up);
        window.addEventListener('pointercancel', this._up);
        // 关键：监听右键菜单弹出，强制停止拖拽，防止“粘手”
        window.addEventListener('contextmenu', this._up);

        this.ro = new ResizeObserver(() => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.refresh(), 150);
        });
        this.ro.observe(this.vp);

        document.addEventListener('visibilitychange', this._vis);
    }
}

customElements.define('crv-marquee', CrvMarquee);

class FeatMarquee extends HTMLElement {
    constructor() {
        super();

        this._raf = null;
        this._paused = false;

        this._x = 0;
        this._speed = 0.8;

        this._total = 0;
        this._baseWidth = 0;

        this._resizeRaf = null;
    }

    connectedCallback() {
        this._wrap = this.querySelector('.feat-wrap');
        this._track = this.querySelector('.feat-track');

        if (!this._wrap || !this._track) return;

        this._speed = parseFloat(this.getAttribute('speed')) || 0.8;

        // 保存原始内容
        if (!this._originalHTML) {
            this._originalHTML = this._track.innerHTML;
        }

        this._build();

        this._ro = new ResizeObserver(() => {
            cancelAnimationFrame(this._resizeRaf);

            this._resizeRaf = requestAnimationFrame(() => {
                this._rebuild();
            });
        });

        this._ro.observe(this._wrap);

        this._bind();

        this._start();
    }

    disconnectedCallback() {
        cancelAnimationFrame(this._raf);
        cancelAnimationFrame(this._resizeRaf);

        if (this._ro) {
            this._ro.disconnect();
        }
    }

    _rebuild() {
        // 保留当前位置比例，避免 resize 时跳动
        const progress = this._total ? this._x / this._total : 0;

        this._build();

        this._x = progress * this._total;
    }

    _build() {
        // 还原原始内容
        this._track.innerHTML = this._originalHTML;

        const style = getComputedStyle(this._track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;

        // 原始内容宽度
        this._baseWidth = this._track.scrollWidth;

        // 容器宽度
        const wrapWidth = this._wrap.offsetWidth;

        /**
         * 核心优化：
         * 不再只复制 1 份
         *
         * 动态计算至少需要多少份内容，
         * 保证轨道宽度始终 > 容器宽度 * 2
         *
         * 这样无论屏幕多宽都不会出现留白
         */
        const minWidth = wrapWidth * 2 + this._baseWidth;

        let cloneCount = Math.ceil(minWidth / this._baseWidth);

        // 至少复制 2 轮
        cloneCount = Math.max(cloneCount, 2);

        const fragment = document.createDocumentFragment();

        for (let i = 0; i < cloneCount; i++) {
            const temp = document.createElement('div');
            temp.innerHTML = this._originalHTML;

            Array.from(temp.children).forEach(node => {
                fragment.appendChild(node);
            });
        }

        this._track.appendChild(fragment);

        /**
         * 单轮滚动距离
         *
         * 注意：
         * 必须使用“原始内容宽度 + gap”
         * 才能保证 reset 时完全无缝
         */
        this._total = this._baseWidth + gap;

        // 内容不足时不滚动
        this._paused = this._total <= wrapWidth;
    }

    _bind() {
        this._wrap.addEventListener('mouseenter', () => {
            this._paused = true;
        });

        this._wrap.addEventListener('mouseleave', () => {
            this._paused = false;
        });

        this._wrap.addEventListener('touchstart', () => {
            this._paused = true;
        }, { passive: true });

        this._wrap.addEventListener('touchend', () => {
            this._paused = false;
        }, { passive: true });
    }

    _start() {
        const tick = () => {
            if (!this._paused && this._total > 0) {
                this._x += this._speed;

                /**
                 * 关键：
                 * 使用减法而不是直接归零
                 * 避免 transform 突变导致闪动
                 */
                if (this._x >= this._total) {
                    this._x -= this._total;
                }

                /**
                 * 保留小数
                 * 不使用 Math.round
                 * 避免低速时卡顿
                 */
                this._track.style.transform =
                    `translate3d(${-this._x}px,0,0)`;
            }

            this._raf = requestAnimationFrame(tick);
        };

        this._raf = requestAnimationFrame(tick);
    }
}

if (!customElements.get('feat-marquee')) {
    customElements.define('feat-marquee', FeatMarquee);
}